var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[_c('i',{class:_vm.iconClass,on:{"click":_vm.openView}},[_vm._v(_vm._s(" " + _vm.title + " ")+" ")]),(!_vm.isRequired)?_c('i',{staticClass:"el-icon-close mouse-pointer",on:{"click":_vm.closeView}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }